import { render } from "./BlockDAGSection.vue?vue&type=template&id=a6b442ee"
const script = {}

import "./BlockDAGSection.vue?vue&type=style&index=0&id=a6b442ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__